<script setup>
/* eslint-disable */
import { ref, onMounted, onUnmounted, watch, nextTick, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useSocketStore } from '@/stores/socket';
import { useLiveSportsStore } from '@/stores/live_sports';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useI18n } from 'vue-i18n';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';
import _ from 'lodash';

const router = useRouter();
const socketStore = useSocketStore();
const liveSportsStore = useLiveSportsStore();
const preSportsStore = usePreSportsStore();
const { t } = useI18n();
const direction = ref(document.dir);
const splideRef = ref(null);
const options = ref({
	direction: direction.value,
	pagination: false,
	// arrows: false,
	// focus: 'center',
	autoWidth: true,
	// gap: 20,
	trimSpace: 'move'
});


const changeLiveSport = (live_sport_id) => {
	if (live_sport_id == 0) {
		selectFavourites();
		return;
	}

	window.scrollTo({ top: 0 });
	liveSportsStore.selectFavourites(false);
	liveSportsStore.setSelectedLiveSportId(live_sport_id);
}

const selectFavourites = () => {
	window.scrollTo({ top: 0 });
	changeLiveSport(null);
	liveSportsStore.selectFavourites(true);
}

const checkArrowsVisibility = () => {
	if (splideRef.value && splideRef.value.splide) {
		const slider = splideRef.value.splide;
		let totalWidth = 0;
		slider.Components.Elements.slides.forEach(slide => {
			const marginRight = parseFloat(window.getComputedStyle(slide).marginRight);
			totalWidth += slide.offsetWidth + marginRight;
		});

		const sliderWidth = slider.Components.Elements.track.clientWidth;

		// Update arrow visibility
		slider.options = {
			...slider.options,
			arrows: totalWidth > sliderWidth
		};

		slider.refresh();
	}
};

watch(() => liveSportsStore.esports, (newValue, oldValue) => {
	if (newValue.length > 0) {
		nextTick().then(() => {
			checkArrowsVisibility();
		});
	}
});

onMounted(() => {
	// Join to liveSports socket channel
	socketStore.join('liveSports');
	window.addEventListener('resize', checkArrowsVisibility);
});


onUnmounted( () => {
	socketStore.leave('liveSports');
	liveSportsStore.emptySelectedLiveSportId();
	window.removeEventListener('resize', checkArrowsVisibility);
});


const selectSport = (sport_id) => {
  if (!preSportsStore.esports || preSportsStore.esports.length === 0) {
    console.warn('Esports data is not loaded yet.');
    return;
  }

  // Set the selected sport state based on the selected sport_id
  if (sport_id === 'all') {
	preSportsStore.setSelectedEsportId(null);
    preSportsStore.selectedPreSportName = 'All';
    preSportsStore.selectedPreSportIcon
  } else {
    preSportsStore.setSelectedEsportId(sport_id);
    preSportsStore.setSelectedPreSportId(sport_id);
  }

  const currentRoute = router.currentRoute.value;
  if (currentRoute) {
    const routeName = currentRoute.name;

    // If the route name includes 'all/upcoming/', push to 'esports-all-upcoming'
    if (routeName.includes('upcoming')) {
		if (sport_id === 'all') {
			router.push({ name: 'esports-all-upcoming' });
		} else {
			router.push({ name: 'esports-upcoming', params: { sport_id } });
		}

    } else if (routeName.includes('live')) {
		if (sport_id === 'all') {
			router.push({ name: 'esports-all-live' });
		} else {
			router.push({ name: 'esports-live', params: { sport_id } });
		}

    } else {
      router.push({ name: 'esports-live', params: { sport_id } });
    }
  }
};

</script>

<template>
<div class="wrapper">
	<div id="game_slides" class="league_slides-inner">
		<!-- Slider start -->

		<Splide :options="options">
            <SplideSlide>
                <a @click="selectSport('all')" class="league-slide-item carousel__item" :class="{ active: $route.name === 'esports-all-upcoming' ||  $route.name === 'esports-all-live'}">
                    <div class="coupon-slider-item">
                        <div class="coupon-slider-content">
                            <p>All</p>
                        </div>
                    </div>
                </a>
            </SplideSlide>
			<SplideSlide v-for="(sport, index) in liveSportsStore.esports" :key="index">
				<a @click="selectSport(sport.id)" class="league-slide-item carousel__item" :class="{ active: sport.id === preSportsStore.selectedEsportId && $route.name !== 'esports-all-upcoming' && $route.name !== 'esports-all-live'}">
					<div class="coupon-slider-item">
						<div class="coupon-slider-content">
							<img v-if="sport.id > 0" :src="liveSportsStore.liveSportWhiteIcon(sport.id)" alt="">
							<img v-else src="/assets/white_sport_icons/Favorite Star.svg" alt="">
							<p>{{ sport.name }}</p>
						</div>
					</div>
				</a>
			</SplideSlide>
		</Splide>
		<!-- slider end -->
	</div>
</div>
</template>
<style scoped>
.league-slider-main .wrapper .league_slides-inner :deep(.splide__arrows .splide__arrow:disabled) {
	display: none !important;
}

html[dir="rtl"] .league-slider-main .wrapper .league_slides-inner :deep(.splide__arrows .splide__arrow--prev) {
	rotate: 180deg;
	right: -10px;
	top: -3px;
	display: flex;
	left: unset;
}

html[dir="rtl"] .league-slider-main .wrapper .league_slides-inner :deep(.splide__arrows .splide__arrow--next) {
	rotate: 180deg;
	left: 0px;
	top: -3px;
	display: flex;
	right: unset;
}
.league-slider-main .wrapper .league_slides-inner :deep(.splide__arrows .splide__arrow--next) {
	right: 0px;
}


@media screen and (min-width: 320px) and (max-width: 767px) {
	html[dir="rtl"] .league-slider-main .wrapper .league_slides-inner :deep(.splide__arrows .splide__arrow--next) {
		left: 0px;
	}

	html[dir="rtl"] .league-slider-main .wrapper .league_slides-inner :deep(.splide__arrows .splide__arrow--prev) {
		right: 0px
	}
}

@media screen and (min-width: 768px) and (max-width: 1280px) {
	html[dir="rtl"] .league-slider-main .wrapper .league_slides-inner :deep(.splide__arrows .splide__arrow--next) {
		left: 0px;
	}

	html[dir="rtl"] .league-slider-main .wrapper .league_slides-inner :deep(.splide__arrows .splide__arrow--prev) {
		right: 0px
	}
}
</style>